<div class="file-container mb-3">
	<div>
		<label class="custom-file-upload mb-0">
			<input type="file" (change)="onFileSelect($event.target.files)"
				accept="video/*,audio/*,.doc,.docx,.xml,.csv,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/*"
				[formControl]="fileControl">
			<img alt="auto" class="rounded" src="assets/images/attachment.png">
		</label>
	</div>
	<div>
		<carousel [cellsToShow]="fileService.fileCarousel.length" [freeScroll]="true" [height]="60" objectFit="contain" [arrows]="false">
			<div class="carousel-cell" *ngFor="let file of fileService.fileCarousel">
				<img src="assets/images/doc.png">
				<span class="icon xs icon-delete" (click)="deleteFile(file)" *ngIf="user.hasFullAccess">
					<fa-icon [icon]="['fas', 'times']" size="xs"></fa-icon>
				</span>
				<span class="file-description">{{ file.fileType.description }}</span>
			</div>
		</carousel>
	</div>
</div>